import { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { userService, orgService } from '../../Services';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faClose,
    faCircleNotch
  } from '@fortawesome/free-solid-svg-icons';

const EditUser = ({id, setAddUser, updateUsers}) => {
    const [user, setUser] = useState([]);
    // eslint-disable-next-line
    const [inputValue, setInputValue] = useState('');
    const [formUploading, setformUploading] = useState(false);
    const [formError, setFormError] = useState(null);
    const [formSuccess, setFormSuccess] = useState(false);

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            width: '100%',
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #b0e2ff',

        })
    }

    const closeModal = () => {
        setAddUser(false);
        document.body.classList.remove('overflow');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setFormSuccess(false);
        setFormError(false);
        setformUploading(true);

        if (!user) {
            setFormError('Please, fill in required fields');
            setformUploading(false);
            return false;
        }
        
        const data = await orgService.addDSO({
            'userID': user.id,
            'orgID': id
        });

        if (data.error)
            setFormError(data.error);
        else if (data.res === 'OK') {
            setFormSuccess(true);
            setTimeout(() => {
                setFormSuccess(false);
            }, 5000);

            updateUsers();

            closeModal();
        }

        setformUploading(false);
    }

    const handleInputChange = value => {
        setInputValue(value);
    };
    
    const loadOptions = async (inputValue) => {
        const data = await userService.search({
            'name': inputValue
        });

        return data.list;
    };

    return <div className="modal">
        <div className="wrapper">
            <FontAwesomeIcon
                icon={faClose}
                style={{ fontSize: 25 }}
                className="close"
                onClick={closeModal}
            />
            <h2>DSO User Profile</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-part">
                    <div className="form-control">
                        <label>User</label>
                        <AsyncSelect
                            onChange={setUser}
                            styles={customStyles}
                            width='100%'
                            menuColor='red'
                            getOptionLabel={e => e.name+' ('+e.Email+')'}
                            getOptionValue={e => e.id}
                            loadOptions={loadOptions}
                            onInputChange={handleInputChange}
                            placeholder="Start typing a last name..."
                        />
                    </div>
                </div>
                <button type="submit" className="blue">{formUploading ? <span><FontAwesomeIcon
                    icon={faCircleNotch}
                    style={{ fontSize: 20, color: '#fff'}}
                    spin
                /> </span> : ''}Submit</button>
            </form>
            {formError ? <div className="alert error">{formError}</div> : ''}
            {formSuccess ? <div className="alert success">Done!</div> : ''}
        </div>
    </div>
};

export default EditUser;